import { useTermsModal } from '../../../contexts/TermsModalContext';
import { TRIAL_DAYS } from '../../../config/trial';
import { pushEvent } from '../../../utils/gtm';

export default function Hero() {
  const { openTermsModal } = useTermsModal();

  return (
    <section className="relative py-16 sm:py-24 flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=E-commerce%20product%20reselling%20business%20scene%20with%20cardboard%20shipping%20boxes%2C%20barcode%20scanner%2C%20smartphone%20showing%20product%20listings%2C%20warehouse%20shelving%20with%20retail%20merchandise%2C%20inventory%20management%20setup%2C%20professional%20online%20selling%20workspace%2C%20organized%20product%20packaging%20area%2C%20modern%20logistics%20environment%20with%20soft%20lighting%2C%20teal%20and%20neutral%20color%20scheme%2C%20clean%20minimalist%20aesthetic%20for%20resale%20business%20operations&width=1920&height=1080&seq=hero-bg-physical-products-002&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 sm:px-6 pt-20 pb-12 sm:pt-24 sm:pb-16 text-center text-white">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-black/40 border border-white/20 text-xs sm:text-sm font-semibold mb-3 sm:mb-4">
          <span className="text-teal-300 text-base sm:text-lg">⏱</span>
          <span>ライバルより「数秒」でも先に仕入れたい、せどり専用通知ツール</span>
        </div>

        <div className="rounded-2xl bg-black/55 backdrop-blur-md px-4 sm:px-8 py-6 sm:py-8 shadow-[0_0_40px_rgba(45,212,191,0.5)] border border-white/15">
          <h1 className="text-3xl sm:text-5xl md:text-6xl font-extrabold mb-4 sm:mb-6 leading-tight tracking-tight">
            <span className="block sm:inline">
              <span className="text-teal-300">新着1分勝負</span>の
            </span>
            <span className="block sm:inline">
              <span className="text-teal-300">せどり</span>で抜け出す
            </span>
          </h1>

          <div className="flex flex-col items-center justify-center gap-3 sm:gap-4">
            <p className="text-sm sm:text-xl md:text-2xl leading-relaxed max-w-3xl">
              <span className="font-bold">業界最速</span><span className="text-xs text-white/80">※</span>監視エンジンで
              <br />複数サイトの<span className="font-bold">新着を24時間自動</span>でチェックし<br />Discordへ即時通知。
            </p>
            <p className="text-xs sm:text-sm md:text-base text-white/85 max-w-3xl">
            仕組み化で取りこぼしによる、機会損失をなくして利益の最大化へ。
            </p>
          </div>
        </div>

        <div className="mt-8 sm:mt-12 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 mb-10 sm:mb-16">
          <button
            type="button"
            onClick={() => openTermsModal(undefined, 'hero')}
            className="w-full sm:w-auto bg-white text-gray-900 px-8 py-3.5 sm:py-4 rounded-lg text-base sm:text-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
          >
            {TRIAL_DAYS}日無料で試す
          </button>
          <a
            href="https://lin.ee/ORf3l7j"
            target="_blank"
            rel="noopener noreferrer nofollow"
            onClick={() => pushEvent('line_friend_add', { button_label: 'hero' })}
            className="w-full sm:w-auto bg-white/10 backdrop-blur-sm text-white border-2 border-white px-5 sm:px-8 py-3.5 sm:py-4 rounded-lg text-xs sm:text-lg font-semibold hover:bg-white/20 transition-colors whitespace-nowrap cursor-pointer"
          >
            まずはLINEで相談する（無料）
          </a>
        </div>

        <div className="max-w-3xl mx-auto rounded-2xl">
          <p
            className="text-xl sm:text-2xl md:text-3xl font-bold mb-3 sm:mb-4 text-white"
            style={{
              textShadow: '0 2px 12px rgba(0,0,0,0.6), 0 1px 4px rgba(0,0,0,0.4)'
            }}
          >
            PACO新着通知ツール 3つの特徴
          </p>
          <div className="grid grid-cols-3 gap-3 sm:gap-6">
            <a
              href="#speed-features"
              className="bg-white/10 backdrop-blur-sm p-3 sm:p-6 rounded-xl block hover:bg-white/20 transition-colors cursor-pointer"
            >
              <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-teal-500 rounded-lg mb-2 sm:mb-4 mx-auto">
                <i className="ri-time-line text-xl sm:text-2xl text-white"></i>
              </div>
              <h3 className="text-sm sm:text-lg font-semibold mb-1 sm:mb-2">24時間監視</h3>
              <p className="text-xs sm:text-sm">寝てても回る</p>
            </a>

            <a
              href="#speed-features"
              className="bg-white/10 backdrop-blur-sm p-3 sm:p-6 rounded-xl block hover:bg-white/20 transition-colors cursor-pointer"
            >
              <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-teal-500 rounded-lg mb-2 sm:mb-4 mx-auto">
                <i className="ri-notification-3-line text-xl sm:text-2xl text-white"></i>
              </div>
              <h3 className="text-sm sm:text-lg font-semibold mb-1 sm:mb-2">
                リアルタイム<br className="sm:hidden" />
                通知
              </h3>
              <p className="text-xs sm:text-sm">Discordに届く</p>
            </a>

            <a
              href="#pricing"
              className="bg-white/10 backdrop-blur-sm p-3 sm:p-6 rounded-xl block hover:bg-white/20 transition-colors cursor-pointer"
            >
              <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-teal-500 rounded-lg mb-2 sm:mb-4 mx-auto">
                <i className="ri-gift-line text-xl sm:text-2xl text-white"></i>
              </div>
              <h3 className="text-sm sm:text-lg font-semibold mb-1 sm:mb-2">{TRIAL_DAYS}日無料</h3>
              <p className="text-xs sm:text-sm">合わなければ解約</p>
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-4 sm:bottom-8 left-0 w-full flex justify-center animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white/60"></i>
      </div>
    </section>
  );
}
